import gql from 'graphql-tag'

export default gql `
  mutation deleteUser($user_id: ID!) {
    deleteUser(
      user_id: $user_id
    )
  }
`